// Core
import { Box, Flex, Grid, Text, Image, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { useState } from 'react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import { ReactComponent as CopyIcon } from 'assets/svg/copy.svg';
import { ReactComponent as CopySuccessIcon } from 'assets/svg/copy-success.svg';
import cube1 from 'assets/img/details/cube-1.png';
import cube2 from 'assets/img/details/cube-2.png';

// Components
import Card from 'components/Card/Card';

const Discount = ({userData}) => { 
	const { colorMode, toggleColorMode } = useColorMode();
  	const isDark = colorMode === 'dark';

  	const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
  	const boxShadow = useColorModeValue('unset', '0px 1px 3px 0px rgba(0, 0, 0, 0.10),0px 1px 2px 0px rgba(0, 0, 0, 0.06)');
  	const dividerCodeDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 12.72%, #FAFDFE 23.59%, #FFF 30.15%, #38A9E1 48.09%, rgba(56, 169, 225, 0.00) 100%)';
  	const dividerCodeWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  	const dividerCode = useColorModeValue(dividerCodeWhite, dividerCodeDark);
  	const dividerDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 32.25%, #FFF 50.39%, #38A9E1 70.91%, rgba(56, 169, 225, 0.00) 100%)';
  	const dividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  	const divider = useColorModeValue(dividerWhite, dividerDark);

	const [copied, setCopied] = useState(false);
	const handleCopy = () => {
	    const text = document.querySelector('.partner-code')?.textContent; 

	    if (text) {
	        navigator.clipboard.writeText(text).then(() => {
	            setCopied(true);
	            setTimeout(() => setCopied(false), 7000); 
	        }).catch(err => console.error('Error copy:', err));
	    }
	};

	return (
	    <Card padding={{base: '16px', md: '20px'}} 
	    	border={border} 
	    	boxShadow={boxShadow} 
	    	mt="32px" 
	    	textAlign="center" 
	    	bg="transparent"
	    	className="animation-account-membership" 
	    	overflow="hidden">
	    	<Text variant="header" fontSize={{base: '36px', md: '48px'}}>
	    		<Text variant="header" fontSize={{base: '36px', md: '48px'}} as="span" position="relative" _before={{
	    			content: '""',
	    			position: 'absolute',
	    			w: '100%',
	    			h: '2px',
	    			bottom: '0px',
	    			background: divider
	    		}} >
	    			LMCT+
	    		</Text> store
	    	</Text>

	    	<Text variant="header-gradient" fontSize={{base: '36px', md: '48px'}}>discount code</Text>

	    	<Card
	    		zIndex="3" 
	    		padding="16px" 
	    		m="18px auto 32px auto" 
	    		bg={ isDark ? '#0D234D' : '#F5FAFF' }
	    		textAlign="left" 
	    		overflow="hidden"
	    		maxW="330px">

	    		<Text zIndex="2" variant="title-md">Enter this code on the website to activate your discount.</Text>

	    		<Flex
	    			zIndex="2"
					mt="16px"
					justifyContent="space-between"
					alignItems="center"
					borderRadius="16px"
					position="relative"
					height="56px"
					fontWeight="800"
					padding="0px 16px"
					overflow="hidden"
					background="linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)"
					boxShadow={ isDark ? '0px 4px 12px 0px rgba(0, 122, 255, 0.50)' : 'unset' }>
					<Text variant="header" fontSize="20px" className="partner-code" color="white">
						15ENTRYLMCT
					</Text>

					<Box borderRadius="8px" bg={ isDark ? '#0D234D' : 'white'} cursor="pointer" p="4px" onClick={handleCopy}>
						{copied ? <CopySuccessIcon fontSize="23px" /> : <CopyIcon fontSize="23px" />}
					</Box>

					<Box 
						boxShadow="-110px -1px 13px #ffffff"
						position="absolute" 
						width="100%"
					    height="2px"
					    left="0"
					    bottom="0"
						bg={dividerCode} /> 
				</Flex>

	    		{ isDark ? <Lines className="abstract-lines" style={{ zIndex: '1'}} /> 
	    			: <LinesWhite className="abstract-lines" style={{ zIndex: '1', opacity: 0.3 }} /> }
	    	</Card>

	    	<Box position="absolute" w="100%" bottom="0px">
	    		{ isDark && <Box position="absolute" 
						bg="rgba(64, 155, 255, 0.82)" 
						filter="blur(70px)" 
						w="50%" h="200px" position="absolute" 
						bottom="-150px" left="50%" transform="translate(-50%, 0)" /> }
	    		<Image className="animation-account-membership-crystal-box1" left="0" bottom="0" position="absolute" src={cube1} alt="Cube" maxW="265px" />
	    		<Image className="animation-account-membership-crystal-box2" right="0" bottom="0" position="absolute" src={cube2} alt="Cube" />
	    	</Box>
	    </Card>
	);
};

export default Discount;